<template>
  <NBox class="p-2 h-full">
    <div
      v-for="row in 34"
      :key="row"
      class="flex justify-center items-center mb-1 gap-1"
    >
      <TextSkeleton
        class="w-full flex justify-end"
        :width="`${Math.random() * 100}%`"
      />
      <TextSkeleton class="w-full" :width="`${Math.random() * 100}%`" />
    </div>
  </NBox>
</template>

<script setup lang="ts">
import TextSkeleton from '@/components/TextSkeleton.vue';
</script>
